/* eslint-disable */
import Bugsnag from '@bugsnag/js'
import { store } from './configStore'

const BugsnagPluginReactModule = require('@bugsnag/plugin-react')
const BugsnagPluginReact = BugsnagPluginReactModule.default || BugsnagPluginReactModule

const releaseStageByEnv = {
  prod: 'production',
  stage: 'staging',
  dev: 'local',
  local: 'local',
  fcrenda: 'production'
}

const appEnv = process.env.REACT_APP_ENV || 'local'
const releaseStage = releaseStageByEnv[appEnv] || appEnv

const getLoggedUsuario = () => {
  const login = store.getState().login
  if (!login || !login.logged || !login.user || !login.user.usuario) return null
  return login.user.usuario
}

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY,
  releaseStage,
  appVersion: process.env.REACT_APP_BUILD_ID,
  enabledReleaseStages: ['production', 'staging'],
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    const usuario = getLoggedUsuario()
    if (!usuario) return

    event.setUser(String(usuario.id), usuario.email)
  }
});

export const bugsnagClient = Bugsnag
/* eslint-disable */

import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';

import App from './pages/App'
import IntranetContainer from './routes/IntranetContainer';

// Cadastro e Login
import authRoutes from './routes/auth';

// Rotas gerais
import commonRoutes from './routes/common';

// Cadastros
import customerRoutes from './routes/module_1/customer';

//Operational
import operationalRoutes from './routes/module_2/request';
import extracaoDadosRoutes from './routes/module_2/extracaoDados';

// Financeiro
import financeRoutes from './routes/module_3';
import integracaoRoutes from './routes/module_4/integracao';

//bugsnag
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export default class Routes extends Component {
  render() {
    return (
      <ErrorBoundary>
        <App>
          <Route path="/">
            <Fragment>
              <IntranetContainer>
                {commonRoutes()}
                {customerRoutes()}
                {operationalRoutes()}
                {extracaoDadosRoutes()}
                {financeRoutes()}
                {integracaoRoutes()}
              </IntranetContainer>
              {authRoutes()}
            </Fragment>
          </Route>
        </App>
      </ErrorBoundary>
    )
  }
};
